import { render, staticRenderFns } from "./UserSettingRecognition.vue?vue&type=template&id=7b279ed4&scoped=true&"
import script from "./UserSettingRecognition.vue?vue&type=script&lang=js&"
export * from "./UserSettingRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b279ed4",
  null
  
)

export default component.exports